import { render, staticRenderFns } from "./BusinessCategoryItem.vue?vue&type=template&id=3cd33fba"
import script from "./BusinessCategoryItem.vue?vue&type=script&lang=js"
export * from "./BusinessCategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports